import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import { GetBlogger } from '../redux/user/blog/blogServicesSync';
import LoaderScreen from './loader/loaderScreen';
import { FaCalendar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HomepageBlog = () => {
  const dispatch = useDispatch();
  const { articleDetails, storiesPageLoad } = useSelector((state) => state.user_blog);

  useEffect(() => {
    dispatch(GetBlogger({ page: 1, limit: 6 }));
  }, [dispatch]);

  return (
    <section className="blog__section section--padding pt-0">
      <div className="container-fluid">
        <div className="section__heading text-center mb-30">
          <h2 className="section__heading--maintitle">Latest Post From Blog</h2>
        </div>
        <div className="blog__section--inner blog__swiper--activation swiper">
          {storiesPageLoad ? (
            <LoaderScreen />
          ) : (
            <>
              <Swiper
                spaceBetween={30}
                slidesPerView={4}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                loop={false}
                pagination={false}
                breakpoints={{
                  0: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                  },
                  375: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                  },
                  575: {
                    spaceBetween: 30,
                    slidesPerView: 2,
                  },
                  767: {
                    spaceBetween: 50,
                    slidesPerView: 3,
                  },
                  991: {
                    spaceBetween: 50,
                    slidesPerView: 3,
                  },
                  1199: {
                    spaceBetween: 30,
                    slidesPerView: 4,
                  },
                }}
                modules={[Pagination, Navigation]}
                className="swiper-wrapper"
              >
                {articleDetails?.docs?.map((blog) => (
                  <SwiperSlide key={blog._id} className="swiper-slide">
                    <div className="blog__items flex flex-col h-full bg-white shadow-lg rounded-lg overflow-hidden">
                      {/* Blog Image */}
                      <div className="blog__thumbnail">
                        <Link className="blog__thumbnail--link display-block" to={`/blog-details/${blog._id}`}>
                          <img
                            className="blog__thumbnail--img display-block object-cover w-full h-[250px]"
                            src={blog.cover_pic}
                            alt={blog.title}
                          />
                        </Link>
                      </div>

                      {/* Blog Content */}
                      <div className="blog__content flex flex-col flex-grow p-4">
                        <ul className="blog__content--meta d-flex">
                          <li className="blog__content--meta__text flex mr-4">
                            <div className="flex items-center gap-1">
                              <FaCalendar className="w-4 h-4 text-red-500" />
                              <span className="mt-1 ml-1">{new Date(blog.createdAt).toLocaleDateString()}</span>
                            </div>
                          </li>
                        </ul>

                        <h3 className="blog__content--title h4">
                          <Link to={`/blog-details/${blog._id}`}>
                            {blog.title.length > 40 ? blog.title.slice(0, 40) + "..." : blog.title}
                          </Link>
                        </h3>

                        <p className="blog__content--desc">
                          {blog.article.replace(/<[^>]+>/g, '').slice(0, 100) + '...'}
                        </p>


                        {/* Read More Button */}
                        <Link className="blog__content--btn primary__btn flex justify-center items-center mt-auto" to={`/blog-details/${blog._id}`}>
                          Read more
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>

                ))}
              </Swiper>
              <div className="swiper-button-next"></div>
              <div className="swiper-button-prev"></div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default HomepageBlog;
